import request from "../../../../helpers/request";

export const getAlertasAbertos = async (idLoja: any, idCliente: number) => {
  if (idLoja === null || idLoja === undefined) return null;
  const lojaPath = Number(idLoja);
  const url = `${process.env.REACT_APP_API}/Alerta/GetAlertasAberto/${lojaPath}?idCliente=${idCliente}`;
  const result = await request({ url });
  return result.data;
};

export const getAlertasAbertosPublico = async (
  idLoja: number,
  idCliente: number,
  apiKey: string,
  pagina: number,
  itensPorPagina: number,
) => {
  let url = `${process.env.REACT_APP_API}/Alerta/GetAlertasAberto/${idLoja}?idCliente=${idCliente}`;

  url += `&pagina=${pagina}&itensPorPagina=${itensPorPagina}`;

  const result = await request({ url, apiKey });
  return result.data;
};
